import * as universal from '../entries/pages/_page.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/+page.ts";
export const imports = ["_app/immutable/nodes/3.4QZyrDIx.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/DwKR0wUy.js","_app/immutable/chunks/DMZiD_i_.js","_app/immutable/chunks/DmC62j6_.js","_app/immutable/chunks/Cop0Gd8t.js","_app/immutable/chunks/zrRTLWHD.js","_app/immutable/chunks/B7lD3_W4.js","_app/immutable/chunks/BT_zozEV.js","_app/immutable/chunks/WaQmNrQ1.js","_app/immutable/chunks/BSTIXOHC.js"];
export const stylesheets = ["_app/immutable/assets/3.hfI2JAKE.css"];
export const fonts = [];
